import { FormEvent, FunctionComponent, JSX } from 'react'
import styles from './checkbox.module.scss'
import MaterialUICheckbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'

interface CheckboxProps {
    id?: string
    checked?: boolean
    required?: boolean
    className?: string
    color?: 'primary' | 'secondary' | 'default'
    disabled?: boolean
    icon?: JSX.Element
    checkedIcon?: JSX.Element
    onChange?: (checked: boolean) => void
    parent?: boolean
    shade?: boolean
    text?: string
    classText?: string
    indeterminate?: boolean
    size?: 'medium' | 'small' | 'large'
}

const Checkbox: FunctionComponent<CheckboxProps> = ({
    id,
    checked,
    required,
    className,
    color,
    disabled,
    icon,
    checkedIcon,
    onChange,
    parent = false,
    shade = false,
    text,
    classText,
    indeterminate = false,
    size = 'medium'
}: CheckboxProps) => {
    function handleChange(event: FormEvent<HTMLInputElement>): void {
        if (onChange) {
            onChange(event.currentTarget.checked)
        }
    }

    return (
        <div className={styles.CheckboxText}>
            <MaterialUICheckbox
                id={id}
                checked={checked}
                required={required}
                className={`${className} ${parent ? styles.Parent : styles.Daycare} ${
                    disabled ? styles.Disabled : ''
                } ${shade ? styles.Shade : ''}`}
                color={color}
                disabled={disabled}
                icon={icon}
                checkedIcon={checkedIcon}
                onChange={handleChange}
                indeterminate={indeterminate}
                size={size}
            />
            <Typography variant='body1' className={`${classText} ${disabled ? styles.Disabled : ''}`}>
                {text}
            </Typography>
        </div>
    )
}

export default Checkbox
